import React from "react";

import TalkTimeIcon from "@uui/MessageSquare02";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { PersonTalkTimeInfo } from "@app/analytics/types";

import Avatar from "@rui/Avatar";
import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";
import { Row } from "@rui/Stack";

export const ParticipantMenuItem = styled(MenuItem)({
  alignItems: "center",
  justifyContent: "space-between",
});

export const ParticipantMenu = styled(Menu)({
  maxHeight: "450px",
  minWidth: "280px",
  maxWidth: "300px",
});

export const ParticipantRow = ({
  participant,
}: {
  participant: PersonTalkTimeInfo;
}) => (
  <>
    <Row variant="left" spacing={1} overflow="hidden" flexShrink={1} pr={1}>
      <Avatar name={participant.name} />
      <Typography variant="bodySecondaryReg" noWrap color="shades.neutral.700">
        {participant.name}
      </Typography>
    </Row>
    <Row variant="right" spacing={0.5} minWidth="50px">
      <TalkTimeIcon sx={{ fontSize: "10px", color: "shades.neutral.300" }} />
      <Typography variant="bodySecondaryReg" color="shades.neutral.600">
        {Math.round(participant.talkTimePercent)}%
      </Typography>
    </Row>
  </>
);
